<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <div class="apcwo-pr-hrnav">
    <span class="apcwo-pr-hrnav__title">{{
      isHr ? 'HR console' : 'Reviews'
    }}</span>
    <a
      v-for="item in visibleItems"
      :key="item.key"
      :href="item.href"
      :class="['apcwo-pr-hrnav__link', {'is-active': item.key === active}]"
    >
      {{ item.label }}
    </a>
  </div>
</template>

<script>
import {urlFor} from '@ohrm/core/util/helper/url';

export default {
  name: 'HrNav',
  props: {
    active: {
      type: String,
      default: '',
    },
    isHr: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      items: [
        {
          key: 'mine',
          label: 'My review',
          href: urlFor('/personalReview/viewMyPersonalReview'),
        },
        {
          key: 'cycles',
          label: 'Review cycles',
          href: urlFor('/personalReview/viewReviewCycles'),
        },
        {
          key: 'reviews',
          label: 'All reviews',
          href: urlFor('/personalReview/viewPersonalReviews'),
        },
        {
          key: 'designees',
          label: 'HR staff',
          href: urlFor('/personalReview/viewReviewDesignees'),
        },
      ],
    };
  },
  computed: {
    visibleItems() {
      if (this.isHr) return this.items;
      // Managers only get their own review and their team's reviews.
      return this.items
        .filter((i) => i.key === 'mine' || i.key === 'reviews')
        .map((i) => (i.key === 'reviews' ? {...i, label: 'Team reviews'} : i));
    },
  },
};
</script>

<style>
.apcwo-pr-hrnav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f1eefa;
}
.apcwo-pr-hrnav__title {
  margin-right: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #741e1e;
}
.apcwo-pr-hrnav__link {
  padding: 5px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  color: #741e1e;
  text-decoration: none;
}
.apcwo-pr-hrnav__link:hover {
  background: #e2dcf3;
}
.apcwo-pr-hrnav__link.is-active {
  background: #741e1e;
  color: #fff;
}
</style>
